<template>
	<div class="page machines">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M88,82H12A12,12,0,0,1,0,70V12A12,12,0,0,1,12,0H88a12,12,0,0,1,12,12V70A12,12,0,0,1,88,82ZM12,4a8,8,0,0,0-8,8V70a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8V12a8,8,0,0,0-8-8Z"/><path d="M0 62h96v4H0zm48 18h4v20h-4z"/><path d="M70 100H30a2 2 0 0 1 0-4h40a2 2 0 0 1 0 4zM50 48a2 2 0 0 1-1.41-.59 1.41 1.41 0 0 1-.25-.3 2.28 2.28 0 0 1-.19-.34 2.66 2.66 0 0 1-.11-.38 1.92 1.92 0 0 1 0-.78 2.22 2.22 0 0 1 .11-.37 2 2 0 0 1 .19-.35 1.41 1.41 0 0 1 .25-.3 2.06 2.06 0 0 1 2.83 0 1.75 1.75 0 0 1 .24.3 1.48 1.48 0 0 1 .19.35 1.57 1.57 0 0 1 .11.37 1.92 1.92 0 0 1 0 .78 1.8 1.8 0 0 1-.11.38 1.63 1.63 0 0 1-.19.34 1.75 1.75 0 0 1-.24.3A2 2 0 0 1 50 48zm10-10a2 2 0 0 1-1.41-.59 12 12 0 0 0-17 0 2 2 0 0 1-2.83-2.83 16 16 0 0 1 22.63 0 2 2 0 0 1-1.39 3.42zm8.48-8.48A2 2 0 0 1 67 29a24 24 0 0 0-34 0 2 2 0 1 1-2.8-2.8 28 28 0 0 1 39.6 0 2 2 0 0 1-1.41 3.41z"/></svg>
					<span class="navigation-title">{{$t('remote-control')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top">
				<FilteredSearch :loaded="machinesLoaded" :list="machines" :click="machineClick" :customText="customerText" :placeholder="$t('search')" :filterAttributes="filterAttributes"/>
			</section>
		</transition>
	</div>
</template>

<script>
import FilteredSearch from '@/components/FilteredSearch.vue'

export default {
	data() {
		return {
			machines: [],
			machinesLoaded: false,
			filterAttributes: [
				{attribute: 'name', text: this.$t('name')},
				{attribute: 'code', text: this.$t('code')},
				{attribute: 'machine_type_name', text: this.$t('machine-type')},
				{attribute: 'serial_number', text: this.$t('serial-number')},
				{attribute: 'spindles_number', text: this.$t('spindles-number')},
			],
		}
	},
	computed: {
		username() {
			return this.$store.getters.getProfile.name;
		},
		id() {
			return this.$store.getters.getProfile.id;
		}
	},
	methods: {
		machineClick(item) {
			this.$router.push({name: 'remote-control', params: {id: item.id}});
		},
		customerText(item) {
			return `${item.name}`
		},
	},
	components: {
		FilteredSearch
	},
	created() {
		let self = this;
		axios.get(`/customers/${self.id}/machines`)
		.then((response) => {
			const machines = response.data.response.machines;
			machines.forEach(machine => {
				if(machine.remote_connection_enabled){
					this.machines.push(machine)
				}
			});
			//self.machines = [...response.data.response.machines];
			self.machinesLoaded = true;
		})
		.catch((err) => {
			self.$router.go(-1);
		});
	},
}
</script>

<style scoped>
</style>